import React, { useRef } from 'react';
import { Link } from 'react-router-dom';

const HorizontalToolScroller = ({ tools }) => {
  const scrollRef = useRef(null);

  const scroll = (direction) => {
    if (scrollRef.current) {
      const scrollAmount = 400;
      scrollRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth',
      });
    }
  };

  return (
    <div className="relative">
      {/* Scroll Left Button */}
      <button
        onClick={() => scroll('left')}
        className="absolute left-0 top-1/2 -translate-y-1/2 z-10 bg-gray-100 dark:bg-gray-800 hover:bg-gray-200 dark:hover:bg-gray-700 rounded-full p-2 shadow-lg transition-colors hidden md:block"
        aria-label="Scroll left"
      >
        <svg className="w-6 h-6 text-gray-900 dark:text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
        </svg>
      </button>

      {/* Scrollable Container */}
      <div
        ref={scrollRef}
        className="flex gap-6 overflow-x-auto scrollbar-hide pb-4 px-2 md:px-12 scroll-smooth"
      >
        {tools.map(([type, tool]) => (
          <Link
            key={type}
            to={tool.path}
            className="flex-shrink-0 w-80 bg-gray-50 dark:bg-gray-800 rounded-lg p-6 hover:bg-gray-100 dark:hover:bg-gray-700 transition-all group cursor-pointer"
          >
            <div className="text-5xl mb-4 group-hover:scale-110 transition-transform text-center">
              {tool.icon}
            </div>
            <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-2 text-center">{tool.name}</h3>
            <p className="text-gray-600 dark:text-gray-400 text-sm text-center mb-4">{tool.description}</p>
            <div className="text-primary-500 dark:text-primary-400 font-medium text-center group-hover:translate-x-2 transition-transform">
              Try it →
            </div>
          </Link>
        ))}
      </div>

      {/* Scroll Right Button */}
      <button
        onClick={() => scroll('right')}
        className="absolute right-0 top-1/2 -translate-y-1/2 z-10 bg-gray-100 dark:bg-gray-800 hover:bg-gray-200 dark:hover:bg-gray-700 rounded-full p-2 shadow-lg transition-colors hidden md:block"
        aria-label="Scroll right"
      >
        <svg className="w-6 h-6 text-gray-900 dark:text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
        </svg>
      </button>

    </div>
  );
};

export default HorizontalToolScroller;

